import { hubConnection } from "signalr-asp-net";
import { config } from "config";
import EventsEmitter from "events/EventsEmitter";
import { updateEntityToCache, updateViewsCache, deleteEntityFromCache } from "api/Cache";

export const SignalrStatus: any = {
    DISCONNECTED: 0,
    STARTED: 1,
    SENT: 2,
    CONNECTED: 3,
};

const maximumTrials = 5;

export default class SignalrService {
    static hub: any;
    static subscribedProjects: any = [];
    static status = SignalrStatus.DISCONNECTED;
    static trials = 0;
    static enabled = true;

    static start() {
        if (!SignalrService.enabled) {
            return;
        }
        try {
            const signalrConnection = hubConnection(config.api.baseUrl.slice(0, -1));
            signalrConnection.qs = { version: "1.0" };

            const hub = signalrConnection.createHubProxy("vfcloudhub");

            let ConnectSignalR = () => {
                console.log(`%csignalR ConnectSignalR service trial:${SignalrService.trials} ....`, "color:yellow");
                signalrConnection
                    .start({ pingInterval: 30000 })
                    .done(() => {
                        console.time("startSignalr");
                        console.log("%csignalR connected and ready...", "color:#73AD21");
                        SignalrService.trials = 0;
                        SignalrService.hub = hub;
                        SignalrService.status = SignalrStatus.CONNECTED;
                        EventsEmitter.emit("signalr", SignalrStatus.CONNECTED);
                    })
                    .fail(() => {
                        console.error("%cCould not connect signalR", "color:red");
                        SignalrService.trials++;
                    });
            };

            hub.on("receive", (message: any) => {
                console.log("signalrmessage:", message);
                message = message.replace(/(\r\n\t|\n|\r|\t)/gm, "");
                SignalrService.processMessage(JSON.parse(message));
            });

            signalrConnection.events.onError = [
                (type: string, error: any) => {
                    console.log("type:", type, "|error:", error);
                },
            ];
            signalrConnection.events.onDisconnect = [
                (type: string, state: any) => {
                    console.log("%csignalr connection disconnected.", "color:red");
                    console.timeEnd("startSignalr");
                    //console.log("type:", type, "|state:", state);
                    if (SignalrService.trials <= maximumTrials) {
                        ConnectSignalR();
                    } else {
                        console.log("%cSignalr service reach maximum trials!", "color:red");
                    }
                },
            ];

            signalrConnection.events.onReconnecting = [
                (type: string, object: any) => {
                    console.log("type:", type, "|object:", object);
                },
            ];
            signalrConnection.events.onStateChanged = [
                (type: string, state: any) => {
                    console.log("type:", type, "|state:", state);
                },
            ];
            SignalrService.status = SignalrStatus.STARTED;

            ConnectSignalR();
        } catch (error: any) {
            console.error("signalr service failed...", error);
        }
    }

    static isProjectSubscribed(projectId: string) {
        return SignalrService.subscribedProjects.find((project: string) => projectId === project);
    }

    static subscribeToProject(projectId: string) {
        if (
            SignalrService.enabled &&
            SignalrService.status === SignalrStatus.CONNECTED &&
            SignalrService.hub &&
            projectId &&
            projectId !== "" &&
            projectId !== "all" &&
            projectId !== null
        ) {
            const found: boolean = SignalrService.isProjectSubscribed(projectId);
            if (!found) {
                SignalrService.subscribedProjects.push(projectId);
                SignalrService.hub.invoke("subscribeToProject", projectId);
                console.log("signalr successfully subsrcibed to project:" + projectId);
                console.log("signalr subscribedProjects:", SignalrService.subscribedProjects);
            }
        }
    }

    static unsubscribeToProject(projectId: string) {
        if (
            SignalrService.status === SignalrStatus.CONNECTED &&
            SignalrService.hub &&
            projectId &&
            projectId !== "" &&
            projectId !== "all" &&
            projectId !== null
        ) {
            const found: boolean = SignalrService.isProjectSubscribed(projectId);
            if (found) {
                if (SignalrService.status === SignalrStatus.CONNECTED && SignalrService.hub) {
                    var index = SignalrService.subscribedProjects.findIndex((prjId: string) => prjId === projectId);
                    if (index > -1) {
                        try {
                            SignalrService.subscribedProjects.splice(index, 1);
                            SignalrService.hub.invoke("unsubscribeToProject", projectId);
                        } catch (e) {
                            console.error(e);
                        }
                        console.log("%csignalr successfully unsubsrcibed to project:" + projectId, "color:red");
                    }
                }
            }
        }
    }

    static cleanSubscription() {
        if (
            SignalrService.status === SignalrStatus.CONNECTED &&
            SignalrService.hub &&
            SignalrService.subscribedProjects.length > 0
        ) {
            var newList = [...SignalrService.subscribedProjects];
            newList.forEach((pid: string) => SignalrService.unsubscribeToProject(pid));
        }
    }

    static processMessage(message: any) {
        console.log("signalr.processMessage:", message);
        if (typeof message === "undefined" || !this.enabled) return;
        var { type, id, project, data, ids } = message;
        if (project === "") {
            return;
        }
        let action = "";
        let signalrMessage = { ...message };
        switch (type) {
            case "entityupdate":
                if (data) {
                    if (data["virtual"] && data["virtual"] === 1) {
                        return;
                    }

                    if (id) {
                        data["ID"] = id;
                    }
                    const entity = updateEntityToCache("entities", project, data);
                    if (entity && entity !== null) {
                        //console.log("entity milko:", entity);
                        // if(entity.state === 'COMPLETE'){
                        //     EventsEmitter.emit("reloadData", "");
                        //     EventsEmitter.emit("updateNotificationNb", "");
                        // }
                        action = "reload";
                        signalrMessage = { ...signalrMessage, action };
                        const folder = entity["file_folder"];
                        if (folder) {
                            signalrMessage = { ...signalrMessage, folder };
                        }
                        const view_type = entity["view_type"];
                        if (view_type === "container") {
                            updateViewsCache(data);
                            signalrMessage = { ...signalrMessage, view_type };
                        }
                    }
                }
                break;
            case "reload":
                if (ids) {
                    const idsArray = ids.includes(",") ? ids.split(",") : ids.split(" ");
                    idsArray.reverse().forEach((id: string) => {
                        console.log("deleting id:", id, "....");
                        deleteEntityFromCache(project, id.trim());
                    });
                    action = "reload_all";
                    signalrMessage = { ...signalrMessage, action };
                }
                break;
            default:
                break;
        }
        EventsEmitter.emit("signalr_update", signalrMessage);
    }
}
